import { Surface } from '../../../../specification/Surface';
import { DEFAULT_RBS_TO_CBS_RATIO } from '../../../../../constants/appConstants';

export const getCaseProjectedTheoreticalRbs = (cuttedBuiltSurface: Surface): Surface =>
  new Surface(Math.max(0, cuttedBuiltSurface.value / DEFAULT_RBS_TO_CBS_RATIO));
